import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/public/public.route').then((m) => m.PUBLIC_ROUTE),
  },
  {
    path: 'administrator',
    loadChildren: () => import('./features/cms/cms.route').then((m) => m.CMS_ROUTE),
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.route').then((m) => m.AUTH_ROUTE),
  },
  { path: '**', redirectTo: '' }, // fallback ke blog
];
